import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthenticatorService } from '../../authentication/service/authenticatorService';

/** Inside the drawer's iframe a signed-out user sees a message, since identity providers refuse to be framed. */
export const docHubHandoffFrameGuard: CanActivateFn = async () => {
  const view = inject(DOCUMENT).defaultView;
  const authenticator = inject(AuthenticatorService);
  const router = inject(Router);
  if (!view || view === view.top || (await authenticator.isAuthenticated())) return true;
  return router.createUrlTree(['/kh-handoff/signed-out']);
};
